// Stylesheets
import './assets/scss/site.scss';

import { hover } from './assets/modules/hover';
import { trigger } from './assets/modules/trigger';
import { logo } from './assets/modules/logo';
import { fluidvideo } from './assets/modules/fluidvideo';
import { drawer } from './assets/modules/drawer';
import { initPhotoSwipeFromDOM } from './assets/modules/photoswipe-init';
import { carousel } from './assets/modules/carousel';

const init = () => {
  hover();
  trigger();
  logo();
  fluidvideo();
  drawer();
  carousel();
  initPhotoSwipeFromDOM('.js-pswp-container');
}

init();